import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const DisabledButtonTooltipCopy = ({
  apiName,
  conflictingTrials
}) => {
  if (conflictingTrials.includes(apiName)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.trial.tooltip.disabledButton",
      options: {
        apiName: I18n.text(`purchaseMotions.products.${apiName}`)
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "purchaseMotions.trial.tooltip.disabledButtonConflict",
    options: {
      conflictingApiName: I18n.text(`purchaseMotions.products.${conflictingTrials[0]}`)
    }
  });
};